import { cn } from "@/utils/css";

export const ProfileCard = ({ className, children }) => {
    return (
        <div className={cn("flex w-full flex-col gap-6 rounded-2xl border border-cm-p-outline bg-cm-p-surface px-8 py-7", className)}>
            {children}
        </div>
    );
};
